import { Record } from "immutable";
import { AnyAction } from "redux";

import { LOADING_STATE } from "@typings/reduxThunkActions";

import {
  ACTION_FAIL,
  ACTION_PENDING,
  ACTION_SUCCESS,
  ACTION_NO_DATA,
} from "@services/AsyncActionCreatorFactory";

import { RecapReducer } from "./recap.typings";
import { FETCH_RECAP } from "./recap.actions";
import { periodsFactory } from "./recap.factories";

const initialState = Record<RecapReducer>({
  state: LOADING_STATE.IDLE,
  data: Record({})(),
});

const recapReducer = (
  store: Record<RecapReducer> = initialState(),
  action: AnyAction,
): Record<RecapReducer> => {
  const { type, payload } = action;

  switch (type) {
    case `${FETCH_RECAP}${ACTION_PENDING}`: {
      return store.set("state", LOADING_STATE.LOADING);
    }
    case `${FETCH_RECAP}${ACTION_FAIL}`: {
      return store.set("state", LOADING_STATE.FAILED);
    }
    case `${FETCH_RECAP}${ACTION_NO_DATA}`: {
      return store.set("state", LOADING_STATE.SUCCEEDED);
    }
    case `${FETCH_RECAP}${ACTION_SUCCESS}`: {
      return store
        .set("data", Record(periodsFactory(payload.data))())
        .set("state", LOADING_STATE.SUCCEEDED);
    }
    default:
      return store;
  }
};

export { recapReducer };
